import styled from 'styled-components'
import { Colors, RecommendJobs, Row } from '@microfrontends/react-components'

export const PictureCss = styled.picture`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	background-color: ${Colors.primary};
`

export const BannerCss = styled.section`
	position: relative;
	width: 100%;
	max-height: 788px;
	display: block;
`
export const TitleSpecialCss = styled.h2`
	position: relative;
	font-family: 'Dela Gothic One';
	font-style: normal;
	font-weight: 400;
	font-size: 19px;
	line-height: 24px;
	text-transform: uppercase;
	display: flex;
	gap: 15px;
	z-index: 9;
	.marker {
	}
	.bg {
		&__oval {
			position: absolute;
			z-index: -1;
			top: -10px;
			left: 5%;
		}
		&__arrow {
			position: absolute;
			z-index: -1;
			top: 0px;
			left: -15%;
		}
	}
`
export const TitleCss = styled.div<{
	colorMarker?: string
}>`
	position: relative;
	z-index: 9;
	padding-left: 30px;
	margin: 16px 0;
	color: ${Colors.darkBlue};
	text-align: center;
	h2 {
		font-family: 'Dela Gothic One';
		font-style: normal;
		font-weight: 400;
		font-size: 19px;
		line-height: 24px;
		text-transform: uppercase;
		> span {
			color: ${Colors.button};
		}
	}
	.marker {
		position: absolute;
		top: 4px;
		left: 0;
		z-index: -1;
	}
	.bg {
		&__oval {
			position: absolute;
			z-index: -1;
			top: -10px;
			left: 5%;
		}
		&__arrow {
			position: absolute;
			z-index: -1;
			top: 0px;
			left: -20%;
			mix-blend-mode: color;
		}
	}
	@media screen and (min-width: 768px) {
		text-align: start;
	}
`

export const Paragraph = styled.p<{
	textAlign?: 'justify' | 'center'
	color?: string
}>`
	position: relative;
	font-size: 15px;
	line-height: 24px;
	margin-bottom: 24px;
	z-index: 9;
	text-align: ${(props) => (props.textAlign ? props.textAlign : 'justify')};
	color: ${(props) => (props.color ? props.color : '#000')};
	> ul {
		list-style: initial;
	}
`

export const Pythago = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 0;
	margin-bottom: 24px;
	.bg__pythago {
		position: relative;
		width: 220px;
		height: 220px;
		.pythago {
			position: absolute;
			width: 366px;
			height: 324px;
			bottom: -51px;
			right: -37px;
		}
	}
	@media screen and (min-width: 768px) {
		margin-top: -100px;
	}
`
export const PythagoLC = styled.div`
	position: relative;
	.pythago__lc {
		position: absolute;
		min-width: 277px;
		min-height: 190px;
		bottom: 0;
		right: 0;
	}
`

export const BaseNumberCss = styled.div<{
	color?: string
	textShadowColor?: string
}>`
	position: relative;
	min-width: 80px;
	width: 80px;
	height: 80px;
	border-radius: 100%;
	border: 1px solid ${(props) => (props.color ? props.color : '#fff')};
	color: ${(props) => (props.color ? props.color : '#fff')};
	text-shadow: 0px 2px 0px
		${(props) =>
		props.textShadowColor ? props.textShadowColor : Colors.darkBlue};
	font-family: 'Dela Gothic One';
	font-style: normal;
	font-weight: 400;
	font-size: 40px;
	line-height: 1;
	text-align: center;
	display: flex;
	align-items: center;
	text-align: center;
	transition: all 0.25s;
	cursor: pointer;
	&:hover {
		.circle {
			visibility: visible;
		}
	}
	.circle {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		visibility: hidden;
		width: 122px;
		&.active {
			visibility: visible;
		}
	}
	&.active,
	&:hover {
		background: #ffc947;
		border: 1px solid #ffffff;
		backdrop-filter: blur(5px);
		color: ${Colors.primary};
		text-shadow: 0px 2px 0px ${Colors.button};
	}
	.text-head {
		position: absolute;
		width: 120px;
		height: 120px;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-shadow: none;
		.svg {
			transform-origin: center center;
			width: 100%;
		}
	}
	> span {
		width: 100%;
		margin-bottom: 4px;
	}

	.db-star {
		position: absolute;
		top: -5%;
		right: -14%;
	}
	@media screen and (min-width: 768px) {
		width: 102px;
		height: 102px;
		font-size: 50px;
		&.active {
			.circle {
				width: 112px;
			}
		}
		.text-head {
			position: absolute;
			width: 140px;
			height: 150px;
		}
	}
`
export const NumberCss = styled.div`
	position: relative;
	/* width: 100%; */
	height: 100%;
	cursor: pointer;
	transition: all 0.25;
	:hover {
		filter: drop-shadow(0px 4px 0px #001744);
	}
	svg {
		display: block;
		margin: 0 auto;
		width: 100px;
		height: 100px;
	}
	span {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -55%);
		font-family: 'Dela Gothic One';
		font-size: 45px;
		line-height: 1;
	}
	@media screen and (min-width: 768px) {
		svg {
			width: 122px;
			height: 122px;
		}
	}
`
export const CardArticleCss = styled.a`
	display: flex;
	flex-direction: column;
	gap: 8px;
	border: 1px solid #f5f5f5;
	background-color: #fff;
	color: ${Colors.text};

	padding: 12px;
	border-radius: 6px;
	width: 100%;
	height: auto;
	&:hover {
		border: 1px solid ${Colors.button};
		.info {
			&__title {
				color: ${Colors.button};
			}
		}
	}
	.thumb {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 232px;
		&__iamge {
			border: 8px solid #fff !important;
			border-radius: 50%;
			&:hover {
				border: 8px solid #c3d8ff !important;
			}
		}
	}
	.info {
		display: flex;
		flex-direction: column;
		gap: 4px;
		&__title {
			font-weight: 600 !important;
			font-size: 15px;
			line-height: 18px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 3; /* number of lines to show */
			line-clamp: 3;
			-webkit-box-orient: vertical;
			height: calc(3 * 18px);
		}
		p {
			margin-bottom: 0;
			font-weight: 400;
			line-height: 18px;
			color: ${Colors.text};
		}
		&__description {
			font-size: 14px;
			line-height: 18px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 3; /* number of lines to show */
			line-clamp: 3;
			-webkit-box-orient: vertical;
			height: calc(3 * 18px);
			color: ${Colors.text};
		}
		&__created-at {
			font-size: 13px;
			color: ${Colors.textGray};
		}
	}
`
export const Window = styled.div<{
	image: string
	content: number | string
	type: 'book' | 'human'
}>`
	position: relative;
	width: 100%;
	height: 220px;
	border: 1px solid #005aff;
	border-radius: 50% 50% 0px 0px;
	margin: 0 auto;
	border-bottom: none;
	background-color: #fff;
	/* &:hover {
		background-color: ${(props) => (props.type === 'book' ? '#ffc947' : '#fff')};
	} */
	&::before {
		position: absolute;
		content: '';
		width: auto;
		height: calc(100% - 15px);
		top: 15px;
		left: 15px;
		right: 15px;
		bottom: 0;
		border: 1px solid #005aff;
		border-bottom: none;
		border-radius: 50% 50% 0px 0px;
		background-image: ${(props) =>
		props.image ? `url(${props.image})` : 'unset'};
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}
	&::after {
		position: absolute;
		content: '${(props) => props.content ?? '1'}';
		width: 42px;
		height: 42px;
		font-family: 'Dela Gothic One';
		font-size: 20px;
		line-height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		top: -15px;
		left: 50%;
		transform: translateX(-50%) rotate(-10deg);
		background: #ff7d55;
		border: 1px solid #005aff;
		border-radius: 50%;
		color: #ffffff;
	}
`

export const WindowBoxCss = styled.div`
	width: 220px;
	.info {
		width: 100%;
		height: 70px;
		background: #005aff;
		color: #ffffff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 5px;
		padding: 0 10px;
		p {
			font-family: 'Dela Gothic One';
			font-size: 12px;
			line-height: 12px;
			text-align: center;
			margin: 0;
			text-transform: uppercase;
		}
		span {
			font-weight: 500;
			font-size: 12px;
			line-height: 14px;
			text-align: center;
			text-transform: capitalize;
		}
	}
`
export const BoxHeaderPrimaryCss = styled.div`
	border-radius: 10px;
	display: block;
	.header {
		background: ${Colors.primary};
		text-align: center;
		padding: 10px 0;
		border-radius: 10px 10px 0 0;
		> span {
			font-size: 19px;
			line-height: 28px;
		}
	}
	.main {
		border: 1px solid ${Colors.primary};
		border-radius: 0 0 10px 10px;
		padding: 12px;
		.title {
			font-size: 15px;
			line-height: 18px;
			text-align: center;
			p {
				font-weight: 700;
				margin-bottom: 5px;
				span {
					color: ${Colors.button};
					font-weight: 700;
				}
			}
			span {
				font-weight: normal;
			}
		}
	}
	@media screen and (min-width: 768px) {
		.main {
			padding: 20px 48px;
		}
	}
`
export const CareerListCss = styled.div`
	.career {
		&__list {
			border-left: 1px dashed ${Colors.primary};
			display: flex;
			flex-direction: column-reverse;
			gap: 5px;
			padding: 20px 0;
		}
	}
`
export const IndustryCss = styled.div`
	.industry {
		&__block {
			&--title {
				font-weight: 600;
				font-size: 16px;
				line-height: 26px;
				text-align: center;
			}
			&--list {
				width: 100%;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				padding: 0 12px;
				gap: 10px;
				.item {
					width: calc(50% - (10px / 2));
					display: flex;
					align-items: center;
					gap: 8px;
					&__color {
						border-radius: 4px;
						min-width: 20px;
						width: 20px;
						height: 20px;
					}
				}
			}
		}
	}
	@media screen and (min-width: 768px) {
		.industry {
			&__block {
				&--list {
					padding: 0 15%;
				}
			}
		}
	}
`

export const ItemCareerPath = styled.div<{ width: number }>`
	height: 30px;
	width: ${(props) => (props.width ? props.width : 100)}%;
	background: linear-gradient(
		to right,
		rgba(0, 90, 255, 0),
		${Colors.primary}
	);
	border-radius: 0px 30px 30px 0px;

	color: #fff;
	text-align: right;
	padding: 0 25px;
	display: flex;
	align-items: center;
	justify-content: end;
	overflow: hidden;
	transition: all 0.25s;
	cursor: pointer;
	&.active,
	&:hover {
		background: linear-gradient(
			to right,
			rgba(0, 90, 255, 0),
			${Colors.button}
		);
		border-radius: 0px 30px 30px 0px;
		color: #000;
		font-weight: bold;
	}
	> div {
		width: calc(100% - 30px);
		text-overflow: ellipsis;
		white-space: nowrap;
		margin: 0;
		font-size: 15px;
		line-height: 22px;
		height: 22px;
		overflow: hidden;
	}
`
export const TextDela = styled.span`
	font-family: 'Dela Gothic One';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	color: #ffffff;
	text-align: center;

	> span {
		font-size: 19px;
		line-height: 28px;
	}
`
export const WowCvWrap = styled(Row)`
	background: #fff;
	border-radius: 12px;
	padding: 35px 0;
	@media (max-width: 767px) {
	}
`
export const GoToNumerologyCss = styled.div`
	a {
		display: flex;
		align-items: center;
		position: absolute;
		top: -5%;
		left: 0;
		z-index: 9;
		color: #fff;
		cursor: pointer;
		span {
			color: #fff;
		}
		svg {
			fill: #fff;
			transform: rotate(90deg);
		}
	}
`

export const RecommendJobsWrap = styled.div`
	background: transparent !important;
	section {
		background: transparent;
		padding: 0;
		.container {
			max-width: unset !important;
			border: unset !important;
			.sectionBlock__content {
				padding: 0;
				.jobBlock{
					border-radius: 10px;
					padding: 12px !important;
					display: flex;
					gap: 10px;
					&__leftCol{
						height: calc(100px - 24px);
						min-width:  calc(100px - 24px);
						margin: 0;
						border: 1px solid #E3E3E3 ;
						border-radius: 10px;
						margin: 0 10px 0 0;
						padding: 5px;
						 a{
							border-radius: 8px;
							img{
								display: inline;
							}
						}
					}
					&__rightCol{
						height: 100%;
						width: calc(100% - (100px - 24px));
						padding:0 ;

					}
					&__link{
						display: flex;
						flex-direction: column;
						/* justify-content: space-between; */
						height: 100%;
					}
					&__title{
						margin: 0;
						font-weight: 700;
						font-size: 15px;
						line-height: 1.1;
						color: ${Colors.text};
					}
					&__price{
						color: ${Colors.button};
					}
					p{
						margin: 0;
					}
				}
			}
		}
	}
`



export const JobsByIndustryWrap = styled(Row)`
	padding: 10px;
`
export const Link = styled.a`
	display: grid;
	grid-template-columns: auto 1fr;
	column-gap: 22px;
	font-size: 13px;
	border-radius: 10px;
	background-color: #fff;
	padding: 10px;
`
export const PopupCareerPathWrap = styled.div`
	padding: 15px;
	overflow: scroll;
	max-height: 100%;
	@media (min-width: 769px) {
		max-height: 500px;
	}
`
